<template>
  <div>
    <Header>
      <template #actions>
        <div class="iqos-tooltip-helper-box mr-8">
          <BaseButton
            variant="secondary"
            color="orange-4"
            icon="qr-code"
            @click="show_test_qr_code = !show_test_qr_code"
            size="md"
          >
            {{ $t("inside.test_button") }}
          </BaseButton>

          <IQOSTooltip
            :title="$t('inside.test_button')"
            :qrLink="testOrderLink"
            :backdrop="false"
            @close="show_test_qr_code = false"
            v-if="show_test_qr_code"
          >
            {{ $t("inside.test_tooltip") }}
          </IQOSTooltip>
        </div>
        <BaseButton
          @click="
            $router.push({
              name: 'subscription_history',
              query: {
                from: 'preview',
              },
            })
          "
          color="v1-grey-10"
          variant="secondary"
          size="md"
        >{{ $t("tables.payments_history") }}</BaseButton>
      </template>
    </Header>
    <PageContainer>
      <!-- <StoreCard :mode="isProUser ? 'pro' : 'preview'" /> -->
      <SystemCard :mode="'preview'" />

      <div class="iqos-grid">
        <div class="iqos-column">
          <StickersBuyCard :mode="'preview'" />
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import StoreCard from '@/components/subscriptions/StoreCard.vue'
import StickersBuyCard from '@/components/StickersBuyCard.vue'

import SystemCard from '@/components/superbilling/SystemCard.vue'

export default {
  data() {
    return {
      show_test_qr_code: false
    }
  },
  computed: {
    testOrderLink() {
      return this.$store.getters.onlineMenuLink('delivery')
    },
    isProUser() {
      return this.$store.getters['subscriptions/isProUser']
    }
  },
  components: {
    StoreCard,
    StickersBuyCard,
    SystemCard
  }
}
</script>

<style>
</style>